import { MY_HUNGRYROOT_ROUTE } from '@hungryroot/routes';

export const MOBILE_HOME_FEED_COOKBOOK_RETURN_STATE = {
  returnTo: MY_HUNGRYROOT_ROUTE,
} as const;

interface MobileHomeFeedCookbookLocationState {
  returnTo: typeof MY_HUNGRYROOT_ROUTE;
}

export function isMobileHomeFeedCookbookReturn(
  state: unknown
): state is MobileHomeFeedCookbookLocationState {
  return (
    typeof state === 'object' &&
    state !== null &&
    'returnTo' in state &&
    (state as MobileHomeFeedCookbookLocationState).returnTo ===
      MY_HUNGRYROOT_ROUTE
  );
}
